/// <reference types="web-bluetooth" />
/// <reference types="w3c-web-serial" />
export async function handleBluetooth(
  name: string,
  serviceuuid: string[],
  characterisuuid: string[],
  messagestoSend: Buffer[],
  handleHexData: (data: string) => void,
  onError = (error: string) => { },
  onDisconnect = () => { },
  onConnect = () => { }
) {
  await navigator.bluetooth
    .requestDevice({
      filters: [
        {
          name: name,
        },
        {
          services: serviceuuid,
        },
      ],
    })
    .then(async (device) => {
      try {
        const server = await device?.gatt?.connect()
        if (server === undefined) {
          onError('Could not connect to device')
          return
        }
        const service = await server.getPrimaryService(serviceuuid[0])
        if (service === undefined) {
          onError('Error accessing device service')
          return
        }
        const characteristic = await service.getCharacteristic(characterisuuid[0])
        if (characteristic === undefined) {
          onError('Error accessing device characteristic')
          return
        }
        await characteristic.startNotifications()
        onConnect()
        characteristic.addEventListener('characteristicvaluechanged', (data: any) => {
          const value = data.target.value as DataView
          const hex = Buffer.from(value.buffer as ArrayBuffer).toString('hex')
          handleHexData(hex)
        })
        characteristic.addEventListener('gattserverdisconnected', () => {
          // handle bluetooth disconnect
          onDisconnect()
        })
        const payload: Uint8Array = new Uint8Array(messagestoSend[0])
        characteristic
          .writeValue(payload as BufferSource)
          .then(() => {
            console.log('write success')
          })
          .catch((error) => {
            onError(error)
          })
      } catch (err: any) {
        onError(err.toString())
      }
    })
    .catch((error) => {
      onError(error)
    })
}



export async function handleSerial(
  baudRate: number,
  handleHexData: (data: string) => void,
  filters?: SerialPortFilter[],
  onError = (error: string) => { },
  onDisconnect = () => { },
  onConnect = () => { }
) {
  navigator.serial
    .requestPort({
      filters: filters,
    })
    .then(async (port) => {
      await port.open({ baudRate: baudRate })
      onConnect()
      var lastReceived = Date.now()
      var reader: ReadableStreamDefaultReader<Uint8Array> | undefined = undefined
      const closeAll = () => {
        if (port.readable && reader) {
          try {
            reader.releaseLock()
            port.close()
          } catch (error) {
            console.log(error)
          }
        }
      }
      var interval = setInterval(() => {
        if (Date.now() - lastReceived > 10000) {
          closeAll()
        }
      }, 1000)
      while (port.readable) {
        reader = port.readable.getReader()
        // set an idle timeout and close the port if no data is received
        try {
          while (true) {
            const { value, done } = await reader.read()
            if (done) {
              onDisconnect()
              break
            }
            if (value) {
              lastReceived = Date.now()
              handleHexData(Buffer.from(value).toString('hex'))
            }
          }
        } catch (error: any) {
          console.log(error.toString())
        } finally {
          closeAll()
          clearInterval(interval)
          onDisconnect()
        }
      }
    })
    .catch((error) => {
      onError(error.toString())
    })
}
